export default {
  REDUX_NAMESPACE: 'IULI/PURCHASES',

  SET_FILTER: 'PURCHASES/SET_FILTER',
  SET_FILTER_COMPETENCY_DATE: 'PURCHASES/SET_FILTER_COMPETENCY_DATE',
  SET_FILTER_DUE_OR_PAYMENT_DATE: 'PURCHASES/SET_FILTER_DUE_OR_PAYMENT_DATE',
  SET_FILTER_STATUS: 'PURCHASES/SET_FILTER_STATUS',
  SET_FILTER_CREATED_BY_ID: 'PURCHASES/SET_FILTER_CREATED_BY_ID',

  SET_SORT_MODEL: 'PURCHASES/SET_SORT_MODEL',

  SET_PAGE_SIZE: 'PURCHASES/SET_PAGE_SIZE',

  SET_INITIAL_STATE: 'PURCHASES/SET_INITIAL_STATE',
};
